/* eslint-disable camelcase */

import { call, put, take, takeEvery, takeLatest, race, select, cancelled } from 'redux-saga/effects'
import axios from 'axios'
import { get } from 'lodash-es'
import { normalize } from 'normalizr'
import { user as userSchema, collection } from '../schemas'

import { selectTags } from './tags'
import { requestAddComment } from './comments'
import API from '../config'
import { selectUser } from './user'
import { REQUEST_ALL_USER_CONTENT } from './userContent'
import { CARD_SAVED, CARD_LIKED, saveCard, cardSaved } from './cardActions'
import { requestPost, receivePost } from './card'
import { getHeaders } from './api'
import { makeGetReferrer } from './entities'
const rootApi = `${API.apiPath}/${API.apiVersion}/`

export const REQUEST_ACCOUNT_PICKS = 'REQUEST_ACCOUNT_PICKS'
export const RECEIVE_ACCOUNT_PICKS = 'RECEIVE_ACCOUNT_PICKS'
export const RECEIVE_ACCOUNT_PICKS_ERROR = 'RECEIVE_ACCOUNT_PICKS_ERROR'
const EMPTY_ACCOUNT_PICKS = 'EMPTY_ACCOUNT_PICKS'
const REQUEST_PICK_CARD = 'REQUEST_PICK_CARD'
export const CARD_PICKED = 'CARD_PICKED'
const CHECK_URL = 'CHECK_URL'
const URL_CHECKED = 'URL_CHECKED'
const URL_ADDED = 'URL_ADDED'
const URL_INVALID = 'URL_INVALID'
const CLEAR_PICK_FORM = 'CLEAR_PICK_FORM'
export const PICK_SUCCESS = 'PICK_SUCCESS'
const REQUEST_REMOVE_PICK = 'REQUEST_REMOVE_PICK'
export const PICK_REMOVED = 'PICK_REMOVED'
export const CREATE_TEMPORARY_CARD = 'CREATE_TEMPORARY_CARD'

// Schedule pick extraction

export const SCHEDULE_PICK_EXTRACTION = 'SCHEDULE_PICK_EXTRACTION'
export const SCHEDULE_SAVE_EXTRACTION = 'SCHEDULE_SAVE_EXTRACTION'

export function schedulePickExtraction(payload) {
  return {
    type: SCHEDULE_PICK_EXTRACTION,
    payload
  }
}

export function scheduleSaveExtraction(payload) {
  return {
    type: SCHEDULE_SAVE_EXTRACTION,
    payload
  }
}

export function* processPickExtraction(action) {
  const apiUrl = `${rootApi}deck/schedule-pick-extraction`
  const { url } = action.payload

  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')

  try {
    const response = yield call(
      [axios, 'post'],
      apiUrl,
      {
        url
      },
      {
        headers: getHeaders(token)
      }
    )

    const normalizedResponse = normalize(
      {
        id: user.data.user.id,
        picks: [response.data],
        homeTabContent: [response.data],
        picks_amount: response.data.picks_amount
      },
      userSchema
    )
    yield put(cardPicked(normalizedResponse))
  } catch (e) {
  } finally {
  }
}

export function* processSaveExtraction(action) {
  const apiUrl = `${rootApi}deck/schedule-save-extraction`
  const { url } = action.payload

  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')

  try {
    const response = yield call(
      [axios, 'post'],
      apiUrl,
      {
        url
      },
      {
        headers: getHeaders(token)
      }
    )
    const normalizedCard = normalize(response.data, collection)
    yield put(receivePost(normalizedCard))
    yield put(cardSaved(response.data.id, false, get(user, 'data.user.id')))
  } catch (e) {
  } finally {
  }
}

export function* pickExtractionSaga() {
  while (true) {
    const action = yield take(SCHEDULE_PICK_EXTRACTION)
    yield call(processPickExtraction, action)
  }
}

export function* saveExtractionSaga() {
  while (true) {
    const action = yield take(SCHEDULE_SAVE_EXTRACTION)
    yield call(processSaveExtraction, action)
  }
}

// Check extraction status

export const CHECK_EXTRACTION_STATUS = 'CHECK_EXTRACTION_STATUS'

export const CHECK_EXTRACTION_STATUS_DONE = 'CHECK_EXTRACTION_STATUS_DONE'
export const CHECK_EXTRACTION_STATUS_PENDING = 'CHECK_EXTRACTION_STATUS_PENDING'
export const CHECK_EXTRACTION_STATUS_ERROR = 'CHECK_EXTRACTION_STATUS_ERROR'
export const CHECK_EXTRACTION_STATUS_COMPLETE = 'CHECK_EXTRACTION_STATUS_COMPLETE'

export function checkExtractionStatus(payload) {
  return {
    type: CHECK_EXTRACTION_STATUS,
    payload
  }
}

export function checkExtractionStatusComplete(payload) {
  return {
    type: CHECK_EXTRACTION_STATUS_COMPLETE,
    payload
  }
}

export function* processCheckExtractionStatus(action) {
  const url = `${rootApi}deck/check-extraction-status`
  const cardId = action.payload
  try {
    const response = yield call([axios, 'get'], url, {
      params: {
        card_id: cardId
      }
    })

    const status = response.data.extraction_status
    if (status === 'done' || status === 'complete') {
      yield put(requestPost(cardId))
    }
  } catch (e) {
  } finally {
  }
}

export function* checkExtractionStatusSaga() {
  yield takeEvery(CHECK_EXTRACTION_STATUS, processCheckExtractionStatus)
}

export function requestAccountPicks(id, maxId, params) {
  return {
    type: REQUEST_ACCOUNT_PICKS,
    payload: {
      id,
      maxId,
      params
    }
  }
}

function receiveAccountPicks(data) {
  return {
    type: RECEIVE_ACCOUNT_PICKS,
    payload: {
      data
    }
  }
}

export function checkUrl(url, autosave, autopick) {
  return {
    type: CHECK_URL,
    payload: {
      url,
      autosave,
      autopick
    }
  }
}

function urlChecked(data) {
  return {
    type: URL_CHECKED,
    payload: data
  }
}

function urlInvalid(error) {
  return {
    type: URL_INVALID,
    payload: error
  }
}

export function clearPickForm() {
  return {
    type: CLEAR_PICK_FORM
  }
}

function pickSuccess(id, userId) {
  return {
    type: PICK_SUCCESS,
    payload: userId
  }
}

export function emptyPicks() {
  return {
    type: EMPTY_ACCOUNT_PICKS
  }
}

export function requestPickCard(cardId, isPrivate = false, comment, link, image, description, name) {
  return {
    type: REQUEST_PICK_CARD,
    payload: { cardId, comment, link, image, description, name, isPrivate }
  }
}

export function cardPicked(data) {
  return {
    type: CARD_PICKED,
    payload: { data }
  }
}

export function requestRemovePick(payload) {
  return {
    type: REQUEST_REMOVE_PICK,
    payload
  }
}

function pickRemoved(payload) {
  return {
    type: PICK_REMOVED,
    payload
  }
}

export function createTemporaryCard(payload) {
  return {
    type: CREATE_TEMPORARY_CARD,
    payload
  }
}

function* postCheckUrl(action) {
  const url = `${rootApi}deck/check-external-link`
  const { url: link, autosave, autopick } = action.payload
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()

  const postParams = {
    link
  }
  try {
    const response = yield call([axios, 'post'], url, postParams, {
      headers: getHeaders(token),
      cancelToken: source.token
    })
    if (autosave || autopick) {
      const isPrivatePick = false
      if (!response.data.card_id) {
        const deck = yield call(
          [axios, 'post'],
          `${rootApi}deck/schedule-link-extraction`,
          {
            ...response.meta,
            url: link
          },
          {
            headers: getHeaders(token)
          }
        )
        if (autosave) {
          yield put(saveCard(deck.data.id))
        } else {
          yield put(requestPickCard(deck.data.id, isPrivatePick))
        }
      } else {
        if (autopick) {
          yield put(requestPickCard(response.data.card_id, isPrivatePick))
        } else if (autosave) {
          yield put(saveCard(response.data.id))
        }
      }
    } else {
      yield put(urlChecked({ ...response, ...action }))
    }
  } catch (e) {
    yield put(urlInvalid('Invalid link'))
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* getAccountPicks(action) {
  const tags = yield select(selectTags)
  const url = `${rootApi}account/get-picks`
  const { maxId, params: payloadParams } = action.payload
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  let id = action.payload.id || get(user, 'data.user.id')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const refId = get(payloadParams, 'refId', id)
  const limit = get(payloadParams, 'limit')

  const params = {
    ...(tags.length > 0 && { tags: tags.join(',') }),
    ...(refId && { referrer_id: refId }),
    ...{ user_id: id, max_id: maxId, limit: limit || 21 }
  }
  try {
    const headers = getHeaders(token)
    const response = yield call([axios, 'get'], url, {
      params,
      headers,
      cancelToken: source.token
    })
    const authoredDecks = response.data.all_decks.map(deck => ({ ...deck, pick_author: response.data.picks_author }))
    const normalizedDecks = normalize({ id, picks: authoredDecks }, userSchema)
    yield put(receiveAccountPicks(normalizedDecks))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

export function* pickCard(action) {
  const url = `${rootApi}account/create-pick`
  const { comment, link, image, description, name, isPrivate } = action.payload
  let { cardId } = action.payload
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  let deck
  const postParams = {
    card_id: cardId,
    is_private_pick: isPrivate
  }
  try {
    if (!cardId) {
      deck = yield call(
        [axios, 'post'],
        `${rootApi}deck/schedule-link-extraction`,
        {
          description,
          image,
          name,
          url: link
        },
        {
          headers: getHeaders(token)
        }
      )
      cardId = deck.data.id
      postParams.card_id = cardId
    }
    if (action.payload.comment) {
      yield put(requestAddComment(cardId, comment))
    }
    const response = yield call([axios, 'post'], url, postParams, {
      headers: getHeaders(token)
    })
    const normalizedResponse = normalize(
      {
        id: user.data.user.id,
        picks: [response.data],
        homeTabContent: [response.data],
        picks_amount: response.data.picks_amount
      },
      userSchema
    )
    yield put(cardPicked(normalizedResponse))
    yield put(pickSuccess(response.data.id, response.data.latest_picker))
  } catch (e) {
  } finally {
  }
}

function* removePick(action) {
  const url = `${rootApi}account/remove-pick`
  const { id } = action.payload
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const postParams = {
    card_id: id
  }
  try {
    yield call([axios, 'post'], url, postParams, {
      headers: getHeaders(token)
    })
    const referrer = yield select(makeGetReferrer())
    yield put(pickRemoved({ id, userId: user.data.user.id, referrer }))
  } catch (e) {
  } finally {
  }
}

export function* accountPicksSaga() {
  while (true) {
    const action = yield take([REQUEST_ACCOUNT_PICKS, REQUEST_ALL_USER_CONTENT])
    yield race({
      task: call(getAccountPicks, action)
    })
  }
}

export function* pickCardSaga() {
  while (true) {
    const action = yield take(REQUEST_PICK_CARD)
    yield call(pickCard, action)
  }
}

export function* checkUrlSaga() {
  yield race({
    task: takeLatest(CHECK_URL, postCheckUrl),
    cancel: take(CHECK_URL)
  })
}

export function* removePickSaga() {
  while (true) {
    const action = yield take(REQUEST_REMOVE_PICK)
    yield call(removePick, action)
  }
}

const initialState = {
  temporaryPick: {},
  newPick: null,
  error: null,
  success: false,
  accountPicksFetching: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case REQUEST_ACCOUNT_PICKS:
      return {
        ...state,
        accountPicksFetching: true
      }
    case RECEIVE_ACCOUNT_PICKS:
      return {
        ...state,
        accountPicksFetching: false
      }
    case EMPTY_ACCOUNT_PICKS:
      return initialState
    case URL_CHECKED:
      return {
        ...state,
        temporaryPick: {
          ...action.payload.data.meta,
          id: action.payload.data.card_id,
          external_link: action.payload.payload.url,
          updated_at: Date.now() / 1000,
          thumbnail: action.payload.data.meta.image
        }
      }
    case URL_ADDED:
      return {
        ...state,
        newPick: action.payload
      }
    case URL_INVALID:
      return {
        ...state,
        temporaryPick: {},
        error: action.payload
      }
    case PICK_SUCCESS:
      return {
        ...state,
        success: true
      }
    case CARD_SAVED: {
      if (Object.keys(state.temporaryPick || {}).length) {
        return {
          ...state,
          temporaryPick: {
            ...state.temporaryPick,
            id: action.payload.id,
            is_saved_by_me: !state.temporaryPick.is_saved_by_me
          }
        }
      } else {
        return state
      }
    }
    case CARD_LIKED: {
      if (Object.keys(state.temporaryPick || {}).length) {
        return {
          ...state,
          temporaryPick: {
            ...state.temporaryPick,
            id: action.payload.id,
            liked_by_me: !state.temporaryPick.liked_by_me
          }
        }
      } else {
        return state
      }
    }
    case CLEAR_PICK_FORM:
      return {
        ...state,
        temporaryPick: {},
        success: false,
        error: null
      }
    default:
      return state
  }
}
